import type { TOC } from '@ember/component/template-only';
import HotelBenchmarkInsightProductOverlay from 'lumen/components/hotel/benchmark-insight/product-overlay';
import HotelBenchmarkInsightUpsellBannerUpsellLight from 'lumen/components/hotel/benchmark-insight/upsell/banner-upsell-light';
import HotelBenchmarkInsightUpsellBannerUpsellTrial from 'lumen/components/hotel/benchmark-insight/upsell/banner-upsell-trial';
import type HotelBenchmarkInsightUpsellController from 'lumen/controllers/hotel/benchmark-insight/upsell';

interface HotelBenchmarkInsightUpsellSignature {
  Args: {
    controller: HotelBenchmarkInsightUpsellController;
    model: unknown;
  };
}

<template>
  <HotelBenchmarkInsightProductOverlay @position="bottom">
    {{#if @controller.isTrialUpsell}}
      <HotelBenchmarkInsightUpsellBannerUpsellTrial />
    {{else}}
      <HotelBenchmarkInsightUpsellBannerUpsellLight />
    {{/if}}
  </HotelBenchmarkInsightProductOverlay>
</template> satisfies TOC<HotelBenchmarkInsightUpsellSignature>;
